import { LatLng } from '../classes/Geocoding'

export const mapOptions = {
    fullscreenControl: false,
    noClear: true,
    streetViewControl: true,
    mapTypeControl: false,
    mapTypeId: 'roadmap',
    heading: 0,
    tilt: 0,
    minZoom: 4,
    maxZoom: 25,
    controlSize: 23
}

export const centerPoints = (mapRef, points: { northEast: LatLng; southWest: LatLng }) => {
    if (mapRef && points) {
        const bounds = new google.maps.LatLngBounds(
            { lat: points.southWest.lat, lng: points.southWest.lng },
            { lat: points.northEast.lat, lng: points.northEast.lng },

        )
        mapRef.fitBounds(bounds)
    }
}
